// Routes through the DS2026 toast shim (react-toastify is aliased to the stacked
// <Toaster> in vite.config.ts). The old react-toastify config (position,
// autoClose: 2000, theme, …) is no longer needed — placement, the 4s dwell, and
// pause-on-hover are handled by the Toaster. See components/FbUI/DS2026-TOAST.md.
import { toast } from 'react-toastify'

export const notifyError = (message: string) => {
  toast.error(message)
}
export const notifySuccess = (message: string) => {
  toast.success(message)
}
export const notifyInfo = (message: string) => {
  toast.info(message)
}
